// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Figtree_fe7946', '__Figtree_Fallback_fe7946', \"Segoe UI\", sans-serif","fontStyle":"normal"},"className":"__className_fe7946"};